import useSWRImmutable from 'swr/immutable'
import { Contract } from '@ethersproject/contracts'
import { CurrencyAmount, Pair, WETH9 } from '@pancakeswap/sdk'
import { qomTokens } from '@pancakeswap/tokens'
import { bitgertRpcProvider } from 'utils/providers'

const QOM_CHAIN_ID = 766

const PAIR_ABI = [
  'function getReserves() view returns (uint112 reserve0, uint112 reserve1, uint32 blockTimestampLast)',
]

export interface QomPrice {
  price: number | undefined
  loading: boolean
  hasError: boolean
}

/**
 * Reads the live WQOM/qUSDT pair reserves on the QOM chain via the public RPC,
 * regardless of which chain the user is connected to.
 */
export const useQomUsdtPrice = (): QomPrice => {
  const wqom = WETH9[QOM_CHAIN_ID]
  const usdt = qomTokens.usdt

  const { data, error, isValidating } = useSWRImmutable(
    wqom && usdt ? ['qom-usdt-price', wqom.address, usdt.address] : null,
    async () => {
      const pairAddress = Pair.getAddress(wqom, usdt)
      const contract = new Contract(pairAddress, PAIR_ABI, bitgertRpcProvider)
      const reserves = await contract.getReserves()
      const r0 = reserves[0].toString()
      const r1 = reserves[1].toString()
      if (r0 === '0' || r1 === '0') return undefined
      const [token0, token1] = wqom.sortsBefore(usdt) ? [wqom, usdt] : [usdt, wqom]
      const pair = new Pair(CurrencyAmount.fromRawAmount(token0, r0), CurrencyAmount.fromRawAmount(token1, r1))
      const priceObj = pair.priceOf(wqom)
      const value = Number(priceObj.toSignificant(6))
      return Number.isFinite(value) ? value : undefined
    },
    {
      refreshInterval: 30_000,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  )

  return {
    price: data,
    loading: isValidating && data === undefined,
    hasError: Boolean(error),
  }
}
